export type EcommercePromoCode = {
  discountCode?: string | null
  displaySavings?: string | null
}

export type MarketingPromo = {
  promoName?: string | null
  amount?: number | null
}

const isPromoCodeMatch = (
  contentfulPromoCode: string | undefined | null,
  apiPromoCode: string | undefined | null,
) =>
  contentfulPromoCode?.toLowerCase().trim() === apiPromoCode?.toLowerCase().trim()

/** Match pricing API marketing promos to datastorage EcommercePromoCode entries (PDP parity). */
export function findPromoMatch(
  promosFromAPI: MarketingPromo[] | undefined,
  promoCodesFromContentful: EcommercePromoCode[] | undefined,
) {
  if (!promosFromAPI?.length) {
    return {
      selectedPromoFromAPI: undefined,
      matchedContentfulPromoCode: undefined,
    }
  }

  if (!promoCodesFromContentful?.length) {
    return {
      selectedPromoFromAPI: promosFromAPI[0],
      matchedContentfulPromoCode: undefined,
    }
  }

  const selectedPromoFromAPI =
    promosFromAPI.find((apiPromo) =>
      promoCodesFromContentful.some((contentfulPromo) =>
        isPromoCodeMatch(contentfulPromo?.discountCode, apiPromo?.promoName),
      ),
    ) ?? promosFromAPI[0]

  const matchedContentfulPromoCode = promoCodesFromContentful.find(
    (contentfulPromo) =>
      isPromoCodeMatch(
        contentfulPromo?.discountCode,
        selectedPromoFromAPI?.promoName,
      ),
  )

  return { selectedPromoFromAPI, matchedContentfulPromoCode }
}

export function resolvePromoDisplay(
  promosFromAPI: MarketingPromo[] | undefined,
  promoCodesFromContentful: EcommercePromoCode[] | undefined,
) {
  const hasMarketingPromo = (promosFromAPI?.length ?? 0) > 0
  if (!hasMarketingPromo) {
    return { discount: null as string | null, discountCode: null as string | null }
  }

  const { selectedPromoFromAPI, matchedContentfulPromoCode } = findPromoMatch(
    promosFromAPI,
    promoCodesFromContentful,
  )

  return {
    discount: matchedContentfulPromoCode?.displaySavings
      ? matchedContentfulPromoCode.displaySavings
      : "SAVINGS",
    discountCode: selectedPromoFromAPI?.promoName ?? null,
  }
}
